<div class="main-container">
  <div class="main-container__header-section">
    @if (isImpersonatedUser) {
      <itc-impersonate-banner />
    }

    @if (hasAccessToThirdPartyIdentityProviderRead() && showSsoMappingRulesBanner() && isCustomRolesFeatureEnabled()) {
      <itc-sso-mapping-rules-banner />
    }

    <itc-header class="main-container__header" />
  </div>

  <div class="main-container__content">
    @if (!isLeftNavigationHidden()) {
      <div class="main-container__left">
        <itc-left-panel />
      </div>
    }
    <div class="main-container__main">
      <div class="main-container__main-scroll" [class.main-container__main-scroll--screen-width]="fitsScreenWidth()">
        <router-outlet />
      </div>
    </div>
  </div>
</div>
